import { Checkbox, FormControlLabel } from '@mui/material';
import styled from 'styled-components';
import sizes from 'styles/sizes';
import { BrandCode } from 'types';

export const CruiseCardCompareCheckboxBase = styled(FormControlLabel)`
  display: flex !important;
  justify-content: center;
  width: fit-content;
  margin-right: 0px !important;

  svg {
    margin-right: -5px;
  }

  span:first-child {
    ${({ theme }) => ({
      [BrandCode.Celebrity]: `
        padding-top: 0;
        padding-bottom: 0;
      `,
    })[theme.brandCode]}
  }

  span:last-child {
    letter-spacing: 0.28px;
    line-height: 21px;
    font-size: 14px;

    ${({ theme }) => ({
      [BrandCode.Celebrity]: `
        font-family: ${theme.typography.fontFamily};
      `,
      [BrandCode.RoyalCaribbean]: `
        font-family: ${theme.typography.fontFamilySemiBold};
        color: ${theme.palette.primary.main};
        letter-spacing: -0.02em;

        @media (min-width: ${sizes.media.tabletMinWidth}px) {
          font-size: 16px;
        }
      `,
    })[theme.brandCode]}
  }
`;

export const CruiseCardCompareCheckboxButton = styled(Checkbox)``;